'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'building';
var width = 384;
var height = 512;
var aliases = [127970,61687];
var unicode = 'f1ad';
var svgPathData = ['M336 0C362.5 0 384 21.49 384 48V464C384 490.5 362.5 512 336 512H240V432C240 405.5 218.5 384 192 384C165.5 384 144 405.5 144 432V512H48C21.49 512 0 490.5 0 464V48C0 21.49 21.49 0 48 0H336zM64 272C64 280.8 71.16 288 80 288H112C120.8 288 128 280.8 128 272V240C128 231.2 120.8 224 112 224H80C71.16 224 64 231.2 64 240V272zM176 224C167.2 224 160 231.2 160 240V272C160 280.8 167.2 288 176 288H208C216.8 288 224 280.8 224 272V240C224 231.2 216.8 224 208 224H176zM256 272C256 280.8 263.2 288 272 288H304C312.8 288 320 280.8 320 272V240C320 231.2 312.8 224 304 224H272C263.2 224 256 231.2 256 240V272zM80 96C71.16 96 64 103.2 64 112V144C64 152.8 71.16 160 80 160H112C120.8 160 128 152.8 128 144V112C128 103.2 120.8 96 112 96H80zM160 144C160 152.8 167.2 160 176 160H208C216.8 160 224 152.8 224 144V112C224 103.2 216.8 96 208 96H176C167.2 96 160 103.2 160 112V144zM272 96C263.2 96 256 103.2 256 112V144C256 152.8 263.2 160 272 160H304C312.8 160 320 152.8 320 144V112C320 103.2 312.8 96 304 96H272z', 'M112 96C120.8 96 128 103.2 128 112V144C128 152.8 120.8 160 112 160H80C71.16 160 64 152.8 64 144V112C64 103.2 71.16 96 80 96H112zM112 224C120.8 224 128 231.2 128 240V272C128 280.8 120.8 288 112 288H80C71.16 288 64 280.8 64 272V240C64 231.2 71.16 224 80 224H112zM208 224C216.8 224 224 231.2 224 240V272C224 280.8 216.8 288 208 288H176C167.2 288 160 280.8 160 272V240C160 231.2 167.2 224 176 224H208zM256 240C256 231.2 263.2 224 272 224H304C312.8 224 320 231.2 320 240V272C320 280.8 312.8 288 304 288H272C263.2 288 256 280.8 256 272V240zM160 112C160 103.2 167.2 96 176 96H208C216.8 96 224 103.2 224 112V144C224 152.8 216.8 160 208 160H176C167.2 160 160 152.8 160 144V112zM304 96C312.8 96 320 103.2 320 112V144C320 152.8 312.8 160 304 160H272C263.2 160 256 152.8 256 144V112C256 103.2 263.2 96 272 96H304z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBuilding = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;